export const categoryArticles: Record<string, {
  slug: string;
  name: string;
  description: string;
  heroDesc: string;
  articles: Array<{
    slug: string;
    title: string;
    excerpt: string;
    date: string;
    imageSeq: string;
    featured?: boolean;
  }>;
}> = {
  resources: {
    slug: 'resources',
    name: '豪门资源',
    description: '全球顶级家族资源、稀缺项目与优质机会',
    heroDesc: '汇聚全球顶级豪门资源，为您精准匹配高端人脉与稀缺机会',
    articles: [
      { slug: 'european-royal-family-network', title: '欧洲皇室家族资源网络深度解析', excerpt: '探寻欧洲主要皇室家族的商业网络与资源布局，了解如何借助皇室资源拓展国际商业版图。', date: '2026-08-01', imageSeq: 'cat-res-royal' },
      { slug: 'middle-east-wealthy-families', title: '中东豪门家族投资图谱与对接策略', excerpt: '深度剖析中东主要豪门家族的投资偏好、产业布局与对接策略，为东方企业家提供参考。', date: '2026-07-25', imageSeq: 'cat-res-middle-east' },
      { slug: 'southeast-asia-tycoons', title: '东南亚顶级华商家族资源全览', excerpt: '系统梳理东南亚最具影响力的华商家族及其掌控的核心产业与资源网络。', date: '2026-07-18', imageSeq: 'cat-res-sea' },
      { slug: 'global-elite-club-network', title: '全球顶级私人会所网络指南', excerpt: '从伦敦的怀特俱乐部到香港的中国会，解密全球最负盛名的精英私人会所与入会路径。', date: '2026-07-10', imageSeq: 'cat-res-club' },
      { slug: 'luxury-real-estate-portfolio', title: '全球顶级豪宅资产配置指南', excerpt: '从纽约中央公园到伦敦海德公园，解析全球顶级豪宅市场的投资逻辑与配置策略。', date: '2026-07-02', imageSeq: 'cat-res-realestate' },
      { slug: 'private-aviation-yacht-resources', title: '私人飞机与超级游艇资源对接手册', excerpt: '为您解析全球私人飞机共享计划与超级游艇租赁的顶级资源网络。', date: '2026-06-25', imageSeq: 'cat-res-aviation' },
    ],
  },
  business: {
    slug: 'business',
    name: '商务合作',
    description: '跨国企业合作、投资并购与商业对接',
    heroDesc: '搭建国际商务合作桥梁，连接全球顶尖企业与投资机构',
    articles: [
      { slug: 'cross-border-ma-strategy', title: '2026跨境并购策略与实战案例', excerpt: '聚焦2026年最热门的跨境并购赛道，深度拆解五大成功案例的操作路径与关键策略。', date: '2026-08-02', imageSeq: 'cat-biz-ma' },
      { slug: 'european-market-entry-guide', title: '中国企业欧洲市场准入全攻略', excerpt: '从政策法规到本土化运营，全方位解析中国企业进入欧洲市场的关键路径与避坑指南。', date: '2026-07-28', imageSeq: 'cat-biz-europe' },
      { slug: 'global-supply-chain-optimization', title: '全球供应链优化与国际采购对接', excerpt: '在全球化新格局下，如何重构供应链体系并实现高效的国际采购对接。', date: '2026-07-20', imageSeq: 'cat-biz-supply' },
      { slug: 'technology-transfer-licensing', title: '国际技术转移与品牌授权合作专题', excerpt: '深度解析国际技术转移的最新趋势与高端品牌授权合作的商业模式。', date: '2026-07-12', imageSeq: 'cat-biz-tech' },
      { slug: 'international-joint-venture', title: '国际合资企业设立与运营管理指南', excerpt: '从法律架构到文化融合，全面解读国际合资企业的设立流程与长期运营管理策略。', date: '2026-07-05', imageSeq: 'cat-biz-jv' },
    ],
  },
  social: {
    slug: 'social',
    name: '精英社交',
    description: '高端私享活动、圈层聚会与国际交流',
    heroDesc: '打造专属精英社交平台，定期举办高端私享活动',
    articles: [
      { slug: 'global-elite-gala-2026', title: '2026全球精英慈善晚宴精彩回顾', excerpt: '汇聚全球300位顶级精英的年度慈善晚宴，现场星光熠熠，爱心与格调并存。', date: '2026-08-03', imageSeq: 'cat-soc-gala' },
      { slug: 'private-art-collection-sharing', title: '私人艺术收藏品鉴会：从印象派到当代', excerpt: '豪门国际联合佳士得举办的私人艺术收藏品鉴会，会员近距离欣赏价值数十亿的艺术珍品。', date: '2026-07-30', imageSeq: 'cat-soc-art' },
      { slug: 'yacht-party-monaco', title: '摩纳哥游艇派对：地中海上的精英社交', excerpt: '豪门国际年度摩纳哥游艇派对，在地中海的碧波之上，开启难忘的精英社交之旅。', date: '2026-07-22', imageSeq: 'cat-soc-yacht' },
      { slug: 'golf-masters-invitational', title: '高尔夫大师邀请赛：果岭上的商务社交', excerpt: '一年一度的豪门国际高尔夫大师邀请赛，在挥杆之间建立深厚的人脉与信任。', date: '2026-07-15', imageSeq: 'cat-soc-golf' },
    ],
  },
  investment: {
    slug: 'investment',
    name: '国际投资',
    description: '全球资产配置、财富管理与投资顾问',
    heroDesc: '提供专业的国际投资咨询与全球资产配置方案',
    articles: [
      { slug: 'global-asset-allocation-2026', title: '2026下半年全球资产配置策略报告', excerpt: '基于宏观经济研判，为您提供2026下半年的全球资产配置建议与风险提示。', date: '2026-08-03', imageSeq: 'cat-inv-asset' },
      { slug: 'family-office-best-practices', title: '家族办公室设立与运营最佳实践', excerpt: '深度分享全球顶级家族办公室的设立经验、治理结构与资产配置框架。', date: '2026-07-26', imageSeq: 'cat-inv-family' },
      { slug: 'emerging-market-investment', title: '新兴市场投资机遇：东南亚与中东专场', excerpt: '聚焦东南亚与中东两大新兴市场，挖掘具有爆发潜力的投资赛道与标的。', date: '2026-07-18', imageSeq: 'cat-inv-emerging' },
      { slug: 'art-investment-collection', title: '艺术品投资与收藏策略指南', excerpt: '从入门到精通，为您揭示艺术品投资的核心逻辑、估值方法与收藏策略。', date: '2026-07-10', imageSeq: 'cat-inv-art' },
      { slug: 'offshore-trust-planning', title: '离岸信托与跨境财富传承规划', excerpt: '全面解读离岸信托的法律架构、税务优化与跨境财富传承的核心要点。', date: '2026-07-02', imageSeq: 'cat-inv-trust' },
      { slug: 'private-equity-fund-investment', title: '私募股权基金投资入门与精选', excerpt: '解析全球顶级私募股权基金的投资策略、业绩表现与参与门槛。', date: '2026-06-25', imageSeq: 'cat-inv-pe' },
    ],
  },
  education: {
    slug: 'education',
    name: '精英教育',
    description: '海外名校申请、贵族教育与综合素质培养',
    heroDesc: '对接全球顶尖教育资源，为高端家庭提供精英教育规划',
    articles: [
      { slug: 'ivy-league-admission-guide', title: '常春藤盟校申请全攻略：从规划到录取', excerpt: '揭秘常春藤盟校录取的核心要素与时间规划，助力子女迈入世界顶级学府。', date: '2026-08-01', imageSeq: 'cat-edu-ivy' },
      { slug: 'british-boarding-school-guide', title: '英国顶级寄宿学校择校指南', excerpt: '从伊顿公学到哈罗公学，深度解读英国九大公学的教育理念与申请流程。', date: '2026-07-20', imageSeq: 'cat-edu-boarding' },
      { slug: 'youth-leadership-program', title: '青少年全球领导力培养项目', excerpt: '豪门国际联合哈佛商学院推出的青少年领导力培养项目，培养下一代的全球视野。', date: '2026-07-10', imageSeq: 'cat-edu-leadership' },
    ],
  },
  lifestyle: {
    slug: 'lifestyle',
    name: '品质生活',
    description: '高端定制旅行、奢侈品鉴赏与生活艺术',
    heroDesc: '探索极致品质生活，定制专属的高端生活方式体验',
    articles: [
      { slug: 'luxury-travel-destinations-2026', title: '2026全球最值得体验的奢华旅行目的地', excerpt: '从南极奢华探险到非洲野奢营地，为您精选2026年最独特的奢华旅行体验。', date: '2026-08-02', imageSeq: 'cat-life-travel' },
      { slug: 'haute-horology-collection', title: '高级制表艺术：顶级腕表收藏指南', excerpt: '深度解读百达翡丽、江诗丹顿等顶级腕表品牌的制表工艺与收藏价值。', date: '2026-07-25', imageSeq: 'cat-life-watch' },
      { slug: 'fine-wine-appreciation', title: '名庄葡萄酒品鉴：从波尔多到勃艮第', excerpt: '豪门国际联合苏富比举办的顶级名庄葡萄酒品鉴会，探索瓶中艺术。', date: '2026-07-15', imageSeq: 'cat-life-wine' },
      { slug: 'custom-luxury-travel-planning', title: '私人定制奢华旅行规划设计', excerpt: '根据您的品味与偏好，为您量身打造独一无二的全球奢华旅行体验。', date: '2026-07-05', imageSeq: 'cat-life-custom' },
    ],
  },
};

export const allCategories = [
  { slug: 'resources', name: '豪门资源' },
  { slug: 'business', name: '商务合作' },
  { slug: 'social', name: '精英社交' },
  { slug: 'investment', name: '国际投资' },
  { slug: 'education', name: '精英教育' },
  { slug: 'lifestyle', name: '品质生活' },
];